import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid, Typography } from '@material-ui/core'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import SearchInput from 'src/components/SearchInput/SearchInput'
import InfoCard from 'src/components/InforCard/InfoCard'
import { getPostGraduateCategory } from './PostGraduation.constants'
import { POST_GRADUATIONS_LIST } from './PostGraduation.data'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './PostGraduationContent.styles'

const PostGraduationContent = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  return (
    <Box className={globalClasses.containerPages}>
      <Box className={globalClasses.topPageBreadcrumbsSearch}>
        <BreadcrumbsComponent
          crumbs={[
            {
              label: t('navbar.start'),
              path: '/'
            },
            {
              label: t('navbar.postgraduate')
            }
          ]}
        />
        <SearchInput
          redirectUrl="/postgraduate/search"
          placeholder={t('post-graduation.search-placeholder')}
        />
      </Box>
      <Box className={classes.root}>
        <Typography variant="h3" className={globalClasses.titleSection}>
          {t('post-graduation.page-title')}
        </Typography>
        <Box className={classes.content}>
          <Grid container spacing={4}>
            {POST_GRADUATIONS_LIST.map((course) => (
              <Grid item xs={12} sm={6} md={4} key={course.id}>
                <InfoCard
                  title={course.title}
                  category={getPostGraduateCategory(course.status)}
                  actionLabel={t('post-graduation.view-more')}
                  link={`/postgraduate/${course.slug}`}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}

export default PostGraduationContent
